import { z } from 'zod';

export const ViolationStatusEnum = z.enum([
  'unapproved',
  'confirmed',
  'action_required',
  'paid',
  'voided',
  'warning',
  'waived',
  'on_hold',
  'disputed',
  'in_city_hearing',
  'upheld',
  'delinquent',
  'in_collections',
]);

export type ViolationStatus = z.infer<typeof ViolationStatusEnum>;

export const VIOLATION_STATUSES = ViolationStatusEnum.options;

export const VIOLATION_STATUS_LABELS: Record<ViolationStatus, string> = {
  unapproved: 'Unapproved',
  confirmed: 'Confirmed',
  action_required: 'Action Required',
  paid: 'Paid',
  voided: 'Voided',
  warning: 'Warning',
  waived: 'Waived',
  on_hold: 'On Hold',
  disputed: 'Disputed',
  in_city_hearing: 'In City Hearing',
  upheld: 'Upheld',
  delinquent: 'Delinquent',
  in_collections: 'In Collections',
};

export type StatusColor = 'default' | 'success' | 'error' | 'info' | 'warning';

export const getViolationStatusColor = (status: string): StatusColor => {
  switch (status.toLowerCase()) {
    case 'confirmed':
    case 'paid':
    case 'upheld':
      return 'success';
    case 'unapproved':
    case 'delinquent':
      return 'error';
    case 'voided':
      return 'info';
    case 'warning':
    case 'action_required':
    case 'disputed':
    case 'in_city_hearing':
    case 'in_collections':
    case 'on_hold':
      return 'warning';
    default:
      return 'default';
  }
};
